'use client';

import { useRouter } from 'next/navigation';

import { useTranslation } from '@/i18n/client';
import { WithLang } from '@/types/general';

export default function NotFoundView(props: WithLang) {
    const router = useRouter();

    const { t } = useTranslation(props.lang, 'common');

    return (
        <>
            <div onClick={() => router.back()} className="ml-8 mt-8 flex w-fit cursor-pointer gap-2 py-2">
                <span className="icon bg-phiArrowLeft" />
                <span className="cursor-pointer text-base xs:text-lg">{t('navigation.back')}</span>
            </div>
            <div className="my-16 flex flex-1 flex-col items-center justify-center gap-y-3">
                <h3 className="text-6xl">404</h3>
                <div className="h-60 w-full bg-fault bg-center bg-no-repeat" />
                <span className="text-xl">{t('pageErrors.404')}</span>
            </div>
        </>
    );
}
